
import Vue, { PropType } from 'vue';
import Card from '~/components/profile/cards/Card.vue';
import { CandidateStudyProgram } from '~/services/CSPService';
import { commonProps } from '~/utils/candidate';
import StudyProgramDetails from '../components/StudyProgramDetails.vue';
import StudyProgramsModal from '../modals/StudyProgramsModal.vue';

export default Vue.extend({
    name: 'StudyPrograms',
    components: {
        Card,
        StudyProgramsModal,
        StudyProgramDetails,
    },
    props: {
        ...commonProps(),
        studyPrograms: {
            type: Array as PropType<CandidateStudyProgram[]>,
            required: true,
        },
    },
    data() {
        return {
            showModal: false,
            programId: null,
        };
    },
    computed: {
        hasNoStudyPrograms(): boolean {
            return !this.studyPrograms.length;
        },
        cardTitle(): string {
            return this.hasNoStudyPrograms
                ? this.$t('profile.studyPrograms.titleWhenEmpty').toString()
                : this.$t('profile.studyPrograms.title').toString();
        },
    },
    methods: {
        editProgram(programId) {
            this.programId = programId;
            this.showModal = true;
        },
        toggleDialog() {
            this.programId = null;
            this.showModal = !this.showModal;
        },
    },
});
